export class Warranty {
  public id: string;
  public warrantyID: number;
  public name: string;
  public description: string;
  public createdDate: Date;
  public updatedDate: Date;
  public isActive: boolean;
}
export class ReturnPolicy {
  public id: string;
  public returnPolicyID: number;
  public name: string;
  public description: string;
  public createdDate: Date;
  public updatedDate: Date;
  public isActive: boolean;
}



// WEBPACK FOOTER //
// ./src/app/models/warranty-type/warranty-model.ts